const channels = [
  {
    name: "官方 App",
    hint: "看板 · 订阅 · 收藏",
    icon: "ri-smartphone-line",
    tone: "bg-primary-100 text-primary-700",
    mark: "核心",
  },
  {
    name: "官方微信公众号",
    hint: "每日精选推送",
    icon: "ri-wechat-2-line",
    tone: "bg-accent-100 text-accent-700",
    mark: "订阅",
  },
  {
    name: "官方微博",
    hint: "实时 · 互动",
    icon: "ri-global-line",
    tone: "bg-secondary-100 text-secondary-800",
    mark: "互动",
  },
  {
    name: "官方小红书",
    hint: "视觉 · 生活方式",
    icon: "ri-camera-line",
    tone: "bg-primary-100 text-primary-700",
    mark: "社区",
  },
  {
    name: "官方抖音",
    hint: "短视频速递",
    icon: "ri-music-2-line",
    tone: "bg-accent-100 text-accent-700",
    mark: "视频",
  },
  {
    name: "官方视频号",
    hint: "深度 · 直播",
    icon: "ri-play-circle-line",
    tone: "bg-secondary-100 text-secondary-800",
    mark: "直播",
  },
];

export default function Channels() {
  return (
    <section id="channels" className="relative overflow-hidden bg-foreground-950 py-16 md:py-20">
      {/* faint texture */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-primary-900/30 via-transparent to-accent-900/20"></div>

      <div className="relative mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-semibold tracking-[0.3em] text-accent-300">
              OFFICIAL CHANNELS
            </span>
            <h2 className="mt-2 font-heading text-3xl font-bold text-background-50 md:text-4xl">
              官方渠道矩阵
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-300 md:text-right">
            认准以下标识，即吃瓜官网官方渠道。客服、订阅与资讯，只走官方入口更安心，
            谨防仿冒账号。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-4 lg:grid-cols-3">
          {channels.map((c) => (
            <a
              key={c.name}
              href="#channels"
              onClick={(e) => e.preventDefault()}
              className="group flex cursor-pointer items-center gap-4 rounded-lg border border-foreground-800 bg-foreground-900/40 p-5 transition-colors hover:border-primary-500/70 hover:bg-foreground-900"
            >
              <span
                className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg ${c.tone}`}
              >
                <i className={`${c.icon} text-xl`}></i>
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <p className="truncate text-[15px] font-semibold text-background-50">
                    {c.name}
                  </p>
                  <span className="hidden rounded border border-accent-400/50 px-1.5 py-px text-[10px] text-accent-300 sm:inline">
                    {c.mark}
                  </span>
                </div>
                <p className="mt-0.5 truncate text-xs text-foreground-400">{c.hint}</p>
              </div>
              <i className="ri-external-link-line text-foreground-500 transition-colors group-hover:text-primary-300"></i>
            </a>
          ))}
        </div>

        {/* official reminder */}
        <div className="mt-8 flex flex-col gap-3 rounded-lg border border-accent-500/30 bg-accent-500/10 p-5 md:flex-row md:items-center md:justify-between">
          <div className="flex items-center gap-3">
            <i className="ri-shield-check-line text-2xl text-accent-300"></i>
            <p className="text-sm leading-relaxed text-foreground-200">
              遇到需要核实身份的场合？请认准带
              <span className="font-semibold text-accent-300">「官方」蓝标</span>
              标识的账号，如需人工协助可直达下方客服区。
            </p>
          </div>
          <a
            href="#contact"
            className="whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-center text-sm font-medium text-accent-950 transition-colors hover:bg-accent-400"
          >
            联系官方客服
          </a>
        </div>
      </div>
    </section>
  );
}